import { inject, injectable } from 'inversify'
import { UserRole } from '@/services/domain/user/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type UserService from '@/services/domain/user/userService'
import type TeamWorkflowService from '@/services/domain/accounts/teamWorkflowService'

@injectable()
export class WebWidgetsAccessControlService {
  constructor(
    @inject(SERVICE_TYPES.UserService) protected readonly userService: UserService,
    @inject(SERVICE_TYPES.TeamWorkflowService) protected readonly teamWorkflowService: TeamWorkflowService,
  ) {}

  public isAllowWebWidgetForCurrentUser() {
    return !(
      this.userService.currentUser().subaccountType === UserRole.USER && this.teamWorkflowService.isUsersWorkflow()
    )
  }
}
